import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static values = {
    elementId: String,
    inputElementId: String
  }
  sortableElement;
  connect(){
    let sortable = document.querySelector(`#${this.elementIdValue}`);
    
    this.sortableElement = new Sortable(sortable, {
      animation: 150,
      dragClass: '!rounded-none',
      ghostClass: 'bg-frankly-olive-200',
      onUpdate: this.update.bind(this),
    });
  }

  update(_event) {
    const hiddenField = document.querySelector(`#${this.inputElementIdValue}`)
    hiddenField.value = this.sortableElement.toArray().toString();
  }
};